export default __webpack_public_path__ + "static/media/cloudyNight.9a6f6c90.gif";